import { FC } from "react";

import { PageContextWrapper } from "@ryde/controls";

import { FeedbacksPageContent } from "./feedbacks.page.content";

export const FeedbacksPage: FC = () => {
  return (
    <PageContextWrapper entity="feedback">
      <FeedbacksPageContent />
    </PageContextWrapper>
  );
};
